import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

// Reuses routes the same way as the default strategy, except during a reload, when every route below the
// root is recreated so that its components initialize again. The root route is always reused because it is
// injected as ActivatedRoute by app-wide services (e.g. NavigationService), and replacing it would leave them
// holding a stale route that no longer tracks navigation.
@Injectable()
export class ReloadRouteReuseStrategy extends BaseRouteReuseStrategy {
  reloading = false;

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const isRoot = !future.parent;
    return (isRoot || !this.reloading) && super.shouldReuseRoute(future, curr);
  }
}
